import { BffApiUpdateItemError, UpdateItemGqlStatus } from '../../../../types';

import {
  InvoiceID,
  InvoiceNanoID,
  InvoiceUUID,
  VoidInvoiceCacheKeys,
  VoidInvoiceGqlQuery
} from '../../invoicesTypes';

import { CACHE_INVOICE_VOID_QUERY } from '../../queries/cacheInvoiceVoid.query';

import { useCacheUpdateQuery } from '../../../common/reactQuery/hooks/useCacheUpdateQuery';

interface CacheInvoiceVoidOptions {
  query?: VoidInvoiceGqlQuery;
  cacheKeys?: VoidInvoiceCacheKeys;
}

export interface CacheInvoiceVoidInput {
  uuid: InvoiceID | InvoiceNanoID | InvoiceUUID;
}

export interface CacheInvoiceVoidResponse {
  invoiceVoid: {
    status: UpdateItemGqlStatus;
  };
}

export type CacheInvoiceVoidError = BffApiUpdateItemError;

const action = 'invoiceVoid';

function useCacheInvoiceVoid<CacheInvoiceVoidRecordType = unknown>({
  query = CACHE_INVOICE_VOID_QUERY,
  cacheKeys
}: CacheInvoiceVoidOptions = {}) {
  const {
    updateCacheQuery,
    updateCacheQueryData,
    updateCacheQueryError,
    updateCacheQueryErrorMessage,
    updateCacheQueryLoading,
    updateCacheQueryReset
  } = useCacheUpdateQuery<
    CacheInvoiceVoidInput,
    CacheInvoiceVoidResponse,
    CacheInvoiceVoidError,
    CacheInvoiceVoidRecordType
  >({ action, query, cacheKeys });

  return {
    voidInvoice: updateCacheQuery,
    voidInvoiceData: updateCacheQueryData,
    voidInvoiceError: updateCacheQueryError,
    voidInvoiceErrorMessage: updateCacheQueryErrorMessage,
    voidInvoiceLoading: updateCacheQueryLoading,
    voidInvoiceReset: updateCacheQueryReset
  };
}

export default useCacheInvoiceVoid;
